import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { LangProvider } from "@/lib/i18n";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { CookieBanner } from "@/components/CookieBanner";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Lobby from "@/pages/Lobby";
import Match from "@/pages/Match";
import Results from "@/pages/Results";
import Profile from "@/pages/Profile";
import Room from "@/pages/Room";
import Ranking from "@/pages/Ranking";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import VerifyEmail from "@/pages/VerifyEmail";
import AdminKpi from "@/pages/AdminKpi";
import DownloadDocs from "@/pages/DownloadDocs";
import JoinLink from "@/pages/JoinLink";

function App() {
  return (
    <div className="App min-h-screen bg-base">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/lobby" element={<ProtectedRoute><Lobby /></ProtectedRoute>} />
              <Route path="/room/:id" element={<ProtectedRoute><Room /></ProtectedRoute>} />
              <Route path="/match/:id" element={<ProtectedRoute><Match /></ProtectedRoute>} />
              <Route path="/results/:id" element={<ProtectedRoute><Results /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/leaderboard" element={<ProtectedRoute><Ranking /></ProtectedRoute>} />
              <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
              <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
              <Route path="/admin/kpi" element={<ProtectedRoute><AdminKpi /></ProtectedRoute>} />
              <Route path="/download-docs" element={<ProtectedRoute><DownloadDocs /></ProtectedRoute>} />
              <Route path="/join/:code" element={<ProtectedRoute><JoinLink /></ProtectedRoute>} />
            </Routes>
            <CookieBanner />
          </BrowserRouter>
          <Toaster position={typeof window !== "undefined" && window.innerWidth < 1024 ? "bottom-center" : "top-right"} theme="dark" />
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
